import { render } from "./MainBannerComponent.vue?vue&type=template&id=4cff12ae&scoped=true"
import script from "./MainBannerComponent.vue?vue&type=script&lang=js"
export * from "./MainBannerComponent.vue?vue&type=script&lang=js"

import "./MainBannerComponent.vue?vue&type=style&index=0&id=4cff12ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cff12ae"]])

export default __exports__